import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Container, Header, Input, Grid, Menu, Divider, Card, Icon } from 'semantic-ui-react';

import { Filters } from '../search/Filters';
import { Result } from '../search/Result';
import { ResultsContainer } from '../search/ResultsContainer';

export const SearchResults = () => {
  const size = 90;
  const [aliases, setAliases] = useState({
    song_cycles: 'song_cycles',
    songs: 'songs',
    composers: 'composers',
    text_authors: 'text_authors'
  });
  const [query, setQuery] = useState('*');
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(size);
  const [activeTab, setActiveTab] = useState('song_cycles');
  const params = useQuery();
  const tabs = [
    { index: 'song_cycles', name: 'Song Cycles', icon: 'book', color: 'yellow' },
    { index: 'songs', name: 'Songs', icon: 'music', color: 'green' },
    { index: 'composers', name: 'Composers', icon: 'user', color: 'blue' },
    { index: 'text_authors', name: 'Text Authors', icon: 'quote left', color: 'orange' }
  ];

  function useQuery () {
    return new URLSearchParams(useLocation().search);
  }

  function handleChange(event) {
    const val = event.target.value;
    setQuery(val);
  }

  function handleTabClick(event, target) {
    const { name } = target;
    setActiveTab(name);
  }

  useEffect(() => {
    

    // get query param from URL
    let q = params.get('q');
    q = !!q && !!q.length ? q : '*';
    setQuery(q);

    // handle pagination
    let start = params.get('start');
  }, []);

  const menuItems = tabs.map((t, i) => {
    return (
      <Menu.Item name={t.index} active={activeTab === t.index} onClick={handleTabClick} key={i}>
        <Icon name={t.icon} color={t.color} /> {t.name}
      </Menu.Item>
    )
  });

  return (
    <Container className='view-container'>
      <Header as='h1' className='title' size='huge'>Search results for:</Header>
      <Input className='search-main' fluid size='large' icon='search' placeholder='Search' value={query} autoFocus={true} onChange={handleChange} />
      <Divider />
      <Menu tabular attached='top'>
        {menuItems}
      </Menu>
      <ResultsContainer query={query} model={activeTab} aliases={aliases} start={start} end={end} size={size} />
      {/* <Grid>
        <Grid.Column width={3}>
          <Filters aggs={aggs} aliases={aliases} />
        </Grid.Column>
        <Grid.Column width={13}>
          <Header as='h4' color='grey' className='subtitle'>Showing {start + 1} - {end} of {total} results</Header>
          <Divider />
          <Menu tabular>
            <Menu.Item link active><Icon name='book' color='yellow'></Icon> Song Cycles &amp; Collections</Menu.Item>
            <Menu.Item link color='green'><Icon name='music' color='green'></Icon>Songs</Menu.Item>
            <Menu.Item link color='blue'>Composers</Menu.Item>
            <Menu.Item link color='orange'>Text Authors</Menu.Item>
          </Menu>
          <Card.Group itemsPerRow={3}>
            {results}
          </Card.Group>
        </Grid.Column>
      </Grid> */}
    </Container>
  );
};
